// @flow
import React, { Component } from 'react'
// $FlowFixMe
export default class extends Component {
  static displayName: any = 'Background'

  render (): any {
    return (
      <div className='background'>
        <div className='layer layer--1'>
          <div className='triangle-wrapper'>
            <svg className='triangle' viewBox='0 0 100 100' preserveAspectRatio='none'>
              <path d='M0,0 L100,100 0,100z' />
            </svg>
          </div>
        </div>
        <div className='layer layer--2'>
          <svg className='triangle' viewBox='0 0 100 100' preserveAspectRatio='none'>
            <path d='M100,0 0,0 0,200z' />
          </svg>
        </div>
        <div className='layer layer--3'>
          <i className='icon icon--analytics' />
        </div>
        <div className='layer layer--4'>
          <i className='icon icon--levels' />
        </div>
        <div className='layer layer--5'>
          <i className='icon icon--goals' />
        </div>
      </div>
    )
  }
}
